import LocalStorageItems from '../constants/LocalStorageItems';
import StudiesDataSortOptions from '../constants/StudiesDataSortOptions';

/**
 * @typedef Study
 * @param {string} studyName
 * @param {string} redirectUrl
 */

/**
 * @typedef StudiesResponse
 * @prop {string} companyName
 * @prop {string} redirectUrl
 * @prop {string} [lastLogin] ISO datetime
 * @prop {string} lastLoginFormatted human-readable date, formatted by locale
 * @prop {Study[]} studies
 */

const sortByLastLogin = (a, b) => {
    // if a exists but b does not,
    // put b after a
    if (a?.lastLogin && !b?.lastLogin) {
        return -1;
    }
    // if b exists but a does not,
    // put a after b
    if (!a?.lastLogin && b?.lastLogin) {
        return 1;
    }
    // if both exist, sort by last login
    if (a?.lastLogin && b?.lastLogin) {
        return b.lastLogin - a.lastLogin;
    }

    // if neither exist, sort by companyName
    if (b.companyName === a.companyName) {
        return 0;
    }
    return b.companyName < a.companyName ? 1 : -1;
};

const sortByCompanyName = (a, b) => {
    // if company names are the same, sort by last login if one is available.
    // If neither are available then both are equal.
    if (b.companyName === a.companyName) {
        if (b?.lastLogin || a?.lastLogin) {
            return sortByLastLogin(a, b);
        }
        return 0;
    }
    return b.companyName < a.companyName ? 1 : -1;
};

/**
 * Sorts studiesData either by last login or company name
 * @param {[StudiesResponse]} studiesData
 * @returns {StudiesResponse[]}
 */
const sortStudiesData = (studiesData) => {
    const sortPreference = localStorage.getItem(LocalStorageItems.STUDIESDATASORT);
    switch (sortPreference) {
        case StudiesDataSortOptions.COMPANYNAME:
            return studiesData?.sort(sortByCompanyName);
        case StudiesDataSortOptions.LASTLOGIN:
        default:
            localStorage.setItem(
                LocalStorageItems.STUDIESDATASORT,
                StudiesDataSortOptions.LASTLOGIN,
            );
            return studiesData?.sort(sortByLastLogin);
    }
};

export default sortStudiesData;
